<template>
  <div>
    <a-form @submit="handleSubmit" :form="form" class="form">
      <a-card title="阿里云OSS配置" class="card" :bordered="true">
        <a-button
          slot="extra"
          size="small"
          :loading="isSubmit"
          v-if="isEdit"
          type="primary"
          @click="handleSubmit">
          提交
        </a-button>
        <a-button slot="extra" size="small" v-if="isEdit" @click="isEdit = false" style="margin-left:15px;">取消</a-button>
        <a-button slot="extra" size="small" v-if="!isEdit" @click="isEdit = true" type="primary">编辑</a-button>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="KeyId"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['oss_keyId',{rules: [{ required: true, message: '请输入KeyId' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.oss_keyId || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="KeySecret"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['oss_keySecret',{rules: [{ required: true, message: '请输入KeySecret' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.oss_keySecret || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="Endpoint(外网)"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['oss_endpoint',{rules: [{ required: true, message: '请输入Endpoint(外网)' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.oss_endpoint || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="Endpoint(内网)"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['oss_internal_endpoint',{rules: [{ required: true, message: '请输入Endpoint(外网)' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.oss_internal_endpoint || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="Bucket"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['oss_bucket',{rules: [{ required: true, message: '请输入Bucket' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.oss_bucket || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
    </a-form>
  </div>
</template>
<script>
import _ from 'lodash'
import { getPre, saveConfig } from '@/api/system'
import { mixin, mixinDevice } from '@/utils/mixin'
import notification from 'ant-design-vue/es/notification'
export default {
  mixins: [mixin, mixinDevice],
  components: {
  },
  created () {
    this.handlePre()
  },
  data () {
    return {
      loading: false,
      isEdit: false,
      isSubmit: false,
      form: this.$form.createForm(this),
      data: {}
    }
  },
  methods: {
    handlePre () {
      getPre({ type: 'oss' }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.data = _.get(res, 'data', {})
          this.form.setFieldsValue(this.data)
        }
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(this.data, this.form.getFieldsValue())
          this.isSubmit = true
          saveConfig(data).then(res => {
            if (_.get(res, 'code') === 200) {
              this.handlePre()
              this.isEdit = false
              this.isSubmit = false
              notification.success({
                message: '更新成功',
                description: '保存成功'
              })
            } else {
              this.isSubmit = false
              notification.warning({
                message: '更新失败',
                description: '请稍后再试'
              })
            }
          })
        }
      })
    }
  }
}
</script>
